import { RoutePermissionGate } from "components/layout/AccessControl";
import AuthLayout from "components/layout/AuthLayout";
import Layout from "components/layout/Layout";
import { RoleGaurd } from "components/layout/RoleGaurd";
import Loadable from "lib/suspenseLoader/Loadable";
import React, { lazy } from "react";
import { Navigate } from "react-router-dom";

import { PATHS } from "configs/routeConfig";

import GuestRoute from "./GuestRoutes";
import PrivateRoute from "./PrivateRoutes";
import VisitListing from "components/woundManagement/VisitListing";
import Notifications from "modules/commonPages/Notifications";
// Master Management
const AddEditTerritory = lazy(() => import("modules/masterManagement/territory/AddEditTerritory"));
const TerritoryList = lazy(() => import("modules/masterManagement/territory/TerritoryList"));
const EtiologyList = lazy(() => import("modules/masterManagement/etiology/EtiologyList.jsx"));
const AddEditEtiology = lazy(() => import("modules/masterManagement/etiology/AddEditEtiology"));
const ProfessionalDesignationList = lazy(() =>
  import("modules/masterManagement/professionalDesignation/ProfessionalDesignationList")
);
const AddEditProfessionalDesignation = lazy(() =>
  import("modules/masterManagement/professionalDesignation/AddEditProfessionalDesignation")
);
const PageTitleList = lazy(() => import("modules/masterManagement/pageTitle/PageTitleList"));
const AddEditPageTitle = lazy(() => import("modules/masterManagement/pageTitle/AddEditPageTitle"));

/** Auth */
const Login = Loadable(lazy(() => import("modules/auth/login/Login")));
const OtpDetails = Loadable(lazy(() => import("modules/auth/otpVerification/OtpDetails")));
const OtpVerification = Loadable(lazy(() => import("modules/auth/otpVerification/OtpVerification")));
const ForgotPassword = Loadable(lazy(() => import("modules/auth/forgotPassword/ForgotPassword")));
const ResetPassword = Loadable(lazy(() => import("modules/auth/resetPassword/ResetPassword")));

/** Dashboard */
const Dashboard = Loadable(lazy(() => import("modules/dashboard/Dashboard")));

/** User Management*/
const UserManagement = Loadable(lazy(() => import("modules/userManagement/UserManagement")));
const PatientsList = Loadable(lazy(() => import("modules/userManagement/patientsDetails/PatientsList")));
const AdminUsers = Loadable(lazy(() => import("modules/userManagement/adminUsers/AdminUsers")));
const AppUsersList = Loadable(lazy(() => import("modules/userManagement/appUsers/AppUsersList")));
const AddAppUser = Loadable(lazy(() => import("modules/userManagement/appUsers/AddAppUser")));
const ViewAppUsersDetails = Loadable(lazy(() => import("modules/userManagement/appUsers/ViewAppUserDetails")));

const AddEditPatient = Loadable(lazy(() => import("modules/userManagement/patientsDetails/AddEditPatient")));
const ViewPatientDetails = Loadable(lazy(() => import("modules/userManagement/patientsDetails/ViewPatientDetails")));
const AdminUserDetails = Loadable(lazy(() => import("modules/userManagement/adminUsers/ViewAdminUserDetails")));
const AdminUserAdd = Loadable(lazy(() => import("modules/userManagement/adminUsers/AddEditAdminUser")));
const AdminUserEdit = Loadable(lazy(() => import("modules/userManagement/adminUsers/AddEditAdminUser")));
/** Content Management*/
const StaticPages = Loadable(lazy(() => import("modules/contentManagement/staticPages/StaticPages")));
const StatisPagesViewDetails = Loadable(
  lazy(() => import("modules/contentManagement/staticPages/ViewStaticPageDetails"))
);
const AddStaticPage = Loadable(
  lazy(() => import("modules/contentManagement/staticPages/StaticPagesActions/AddStaticPage"))
);

/** Role */
const RoleManagement = Loadable(lazy(() => import("modules/role/RoleManagement")));
const RolePage = Loadable(lazy(() => import("modules/role/Role")));
const AddEditRole = Loadable(lazy(() => import("modules/role/AddEditRole")));
const ViewRole = Loadable(lazy(() => import("modules/role/ViewRole")));

/** Email And Notifications */
const EmailTemplatesManagement = Loadable(lazy(() => import("modules/emailTemplates/EmailTemplatesManagement")));
const EmailTemplates = Loadable(lazy(() => import("modules/emailTemplates/EmailTemplates")));
const AddEditTemplates = Loadable(lazy(() => import("modules/emailTemplates/AddEditTemplates")));
const ViewTemplates = Loadable(lazy(() => import("modules/emailTemplates/ViewTemplates")));

/** Master Management */
const MasterManagement = Loadable(lazy(() => import("modules/masterManagement/MasterManagement")));

/** Master Matching Parameters */

const AddEditQuestionnarie = Loadable(lazy(() => import("modules/questionarie/AddEditQuetionnarie")));
const QuestionnarieListing = Loadable(lazy(() => import("modules/questionarie/QuestionnarieListing")));

/** Settings */
const Settings = Loadable(lazy(() => import("modules/settings/Settings")));
const GeneralSettings = Loadable(lazy(() => import("modules/settings/generalSettings/GeneralSettings")));
const SmtpSmsDetails = Loadable(lazy(() => import("modules/settings/smtpSmsDetails/SmtpSmsDetails")));
/** Master Management */
const FourZeroFourPage = Loadable(lazy(() => import("modules/commonPages/FourZeroFourPage")));
const ThankyouPage = Loadable(lazy(() => import("modules/commonPages/ThankyouPage")));
const ComingSoonPage = Loadable(lazy(() => import("modules/commonPages/ComingSoonPage")));

/** My Profile */
const MyProfile = Loadable(lazy(() => import("modules/myProfile/MyProfile")));
const EditMyProfile = Loadable(lazy(() => import("modules/myProfile/EditProfile")));

/** Change Password */
const ChangePasswordPage = Loadable(lazy(() => import("modules/changePassword/ChangePassword")));
/** Wound Management */
const WoundDetails = Loadable(lazy(() => import("../components/woundManagement/WoundDetails")));
const NotAssessReasonTableList = Loadable(
  lazy(() => import("../modules/masterManagement/notAssessReasons/NotAssessReasonTableList"))
);
const NotAssessReasonList = Loadable(
  lazy(() => import("../modules/masterManagement/notAssessReasons/NotAssessReasonList"))
);
const AddEditNotAssessReason = Loadable(
  lazy(() => import("../modules/masterManagement/notAssessReasons/AddEditNotAssessReason"))
);

const MainRoutes = {
  path: PATHS.DEFAULT,
  element: (
    <PrivateRoute>
      <Layout />
    </PrivateRoute>
  ),
  children: [
    // Dashboard
    {
      path: PATHS.DASHBOARD,
      element: (
        <RoleGaurd module="Dashboard" permission="View">
          <Dashboard type="view" />
        </RoleGaurd>
      ),
    },
    // User management
    {
      path: PATHS.USER,
      element: <UserManagement />,
      children: [
        {
          path: PATHS.USER_LIST,
          element: <PatientsList />,
        },
        {
          path: `${PATHS.USER_LIST}/${PATHS.VIEW}/:id`,
          element: (
            <RoleGaurd module="Patients" permission="View" isRedirect redirectUrl="/">
              <ViewPatientDetails type="view" />
            </RoleGaurd>
          ),
        },
        {
          path: PATHS.USER_LIST + "/" + PATHS.CREATE,
          element: (
            <RoleGaurd
              module="Patients"
              permission="Create"
              isRedirect
              redirectUrl={`${PATHS.USER}/${PATHS.USER_LIST}`}
            >
              <AddEditPatient type="add" />
            </RoleGaurd>
          ),
        },
        {
          path: `${PATHS.USER_LIST}/${PATHS.EDIT}/:id`,
          element: (
            <RoleGaurd module="Patients" permission="Edit" isRedirect redirectUrl={`${PATHS.USER}/${PATHS.USER_LIST}`}>
              <AddEditPatient type="edit" />
            </RoleGaurd>
          ),
        },
        {
          path: PATHS.ADMIN_USER,
          element: (
            <RoleGaurd module="Admin User" permission="View" isRedirect redirectUrl="/">
              <AdminUsers />
            </RoleGaurd>
          ),
        },
        {
          path: PATHS.ADMIN_USER + "/" + PATHS.VIEW + "/:id",
          element: (
            <RoleGaurd module="Admin User" permission="View" isRedirect redirectUrl="/">
              <AdminUserDetails type="view" />,
            </RoleGaurd>
          ),
        },
        {
          path: PATHS.ADMIN_USER + "/" + PATHS.CREATE,
          element: (
            <RoleGaurd
              module="Admin User"
              permission="Create"
              isRedirect
              redirectUrl={`${PATHS.USER}/${PATHS.ADMIN_USER}`}
            >
              <AdminUserAdd type="add" />
            </RoleGaurd>
          ),
        },
        {
          path: PATHS.ADMIN_USER + "/" + PATHS.EDIT + "/:id",
          element: (
            <RoleGaurd
              module="Admin User"
              permission="Edit"
              isRedirect
              redirectUrl={`${PATHS.USER}/${PATHS.ADMIN_USER}`}
            >
              <AdminUserEdit type="edit" />
            </RoleGaurd>
          ),
        },
        {
          path: PATHS.APP_USER,
          element: (
            <RoleGaurd module="User" permission="View" isRedirect redirectUrl="/">
              <AppUsersList />
            </RoleGaurd>
          ),
        },
        {
          path: PATHS.APP_USER + "/" + PATHS.CREATE,
          element: (
            <RoleGaurd module="User" permission="Create" isRedirect redirectUrl={`${PATHS.USER}/${PATHS.APP_USER}`}>
              <AddAppUser type="add" />
            </RoleGaurd>
          ),
        },
        {
          path: `${PATHS.APP_USER}/${PATHS.EDIT}/:id`,
          element: (
            <RoleGaurd module="User" permission="Edit" isRedirect redirectUrl={`${PATHS.USER}/${PATHS.APP_USER}`}>
              <AddAppUser type="edit" />
            </RoleGaurd>
          ),
        },

        {
          path: `${PATHS.APP_USER}/${PATHS.VIEW}/:id`,
          element: (
            <RoleGaurd module="User" permission="View" isRedirect redirectUrl="/">
              <ViewAppUsersDetails type="view" />
            </RoleGaurd>
          ),
        },
        {
          path: "",
          element: <Navigate to={`${PATHS.USER}/${PATHS.APP_USER}`} />,
        },
        {
          path: PATHS.ANY,
          element: <Navigate to={`${PATHS.USER}/${PATHS.APP_USER}`} />,
        },
      ],
    },
    // New Master

    {
      path: PATHS.MASTER_MANAGEMENT,
      element: <MasterManagement />,
      // Terriroey
      children: [
        {
          path: PATHS.TERRITORY,
          element: <TerritoryList />,
        },
        {
          path: PATHS.TERRITORY + "/" + PATHS.CREATE,
          element: (
            <RoleGaurd module="Master Territory" permission="Create" isRedirect redirectUrl="/">
              <AddEditTerritory type="add" />
            </RoleGaurd>
          ),
        },
        {
          path: PATHS.TERRITORY + "/" + PATHS.VIEW,
          element: (
            <RoleGaurd module="Master Territory" permission="View" isRedirect redirectUrl="/">
              <TerritoryList type="view" />
            </RoleGaurd>
          ),
        },
        {
          path: PATHS.TERRITORY + "/" + PATHS.EDIT + "/:id",

          element: (
            <RoleGaurd module="Master Territory" permission="Edit" isRedirect redirectUrl="/">
              <AddEditTerritory type="edit" />
            </RoleGaurd>
          ),
        },

        // Etiology
        {
          path: PATHS.ETIOLOGY,
          element: <EtiologyList />,
        },
        {
          path: PATHS.ETIOLOGY + "/" + PATHS.CREATE,
          element: (
            <RoleGaurd module="Master Etiology" permission="Create" isRedirect redirectUrl="/">
              <AddEditEtiology type="add" />
            </RoleGaurd>
          ),
        },
        {
          path: PATHS.ETIOLOGY + "/" + PATHS.VIEW,
          element: (
            <RoleGaurd module="Master Etiology" permission="View" isRedirect redirectUrl="/">
              <EtiologyList />
            </RoleGaurd>
          ),
        },
        {
          path: PATHS.ETIOLOGY + "/" + PATHS.EDIT + "/:id",
          element: (
            <RoleGaurd module="Master Etiology" permission="Edit" isRedirect redirectUrl="/">
              <AddEditEtiology type="edit" />
            </RoleGaurd>
          ),
        },

        // PROFESSIONAL DESIGNATION
        {
          path: PATHS.PROFESSIONAL_DESIGNATION,
          element: <ProfessionalDesignationList />,
        },
        {
          path: PATHS.PROFESSIONAL_DESIGNATION + "/" + PATHS.CREATE,
          element: (
            <RoleGaurd module="Master Professional Designation" permission="Create" isRedirect redirectUrl="/">
              <AddEditProfessionalDesignation type="add" />
            </RoleGaurd>
          ),
        },
        {
          path: PATHS.PROFESSIONAL_DESIGNATION + "/" + PATHS.VIEW,
          element: (
            <RoleGaurd module="Master Professional Designation" permission="View" isRedirect redirectUrl="/">
              <ProfessionalDesignationList />
            </RoleGaurd>
          ),
        },
        {
          path: PATHS.PROFESSIONAL_DESIGNATION + "/" + PATHS.EDIT + "/:id",
          element: (
            <RoleGaurd module="Master Professional Designation" permission="Edit" isRedirect redirectUrl="/">
              <AddEditProfessionalDesignation type="edit" />
            </RoleGaurd>
          ),
        },

        //PAGE TITLE
        {
          path: PATHS.PAGE_TITLE,
          element: <PageTitleList />,
        },
        {
          path: PATHS.PAGE_TITLE + "/" + PATHS.CREATE,
          element: (
            <RoleGaurd module="Page Title" permission="Create" isRedirect redirectUrl="/">
              <AddEditPageTitle type="add" />
            </RoleGaurd>
          ),
        },
        {
          path: PATHS.PAGE_TITLE + "/" + PATHS.VIEW,
          element: (
            <RoleGaurd module="Page Title" permission="View" isRedirect redirectUrl="/">
              <PageTitleList />
            </RoleGaurd>
          ),
        },
        {
          path: PATHS.PAGE_TITLE + "/" + PATHS.EDIT + "/:id",
          element: (
            <RoleGaurd module="Page Title" permission="Edit" isRedirect redirectUrl="/">
              <AddEditPageTitle type="edit" />,
            </RoleGaurd>
          ),
        },
        //not assess reason
        {
          path: PATHS.NOT_ASSESS_REASON,
          element: <NotAssessReasonList />,
        },
        {
          path: PATHS.NOT_ASSESS_REASON + "/" + PATHS.CREATE,
          element: (
            <RoleGaurd module="Not Assess Reasons" permission="Create" isRedirect redirectUrl="/">
              <AddEditNotAssessReason type="add" />
            </RoleGaurd>
          ),
        },
        {
          path: PATHS.NOT_ASSESS_REASON + "/" + PATHS.VIEW,
          element: (
            <RoleGaurd module="Not Assess Reasons" permission="View" isRedirect redirectUrl="/">
              <NotAssessReasonList />
            </RoleGaurd>
          ),
        },
        {
          path: PATHS.NOT_ASSESS_REASON + "/" + PATHS.EDIT + "/:id",
          element: (
            <RoleGaurd module="Not Assess Reasons" permission="Edit" isRedirect redirectUrl="/">
              <AddEditNotAssessReason type="edit" />
            </RoleGaurd>
          ),
        },
      ],
    },

    {
      path: PATHS.QUESTIONNARIE,
      element: (
        <RoleGaurd module="Questionnaire" permission="View" isRedirect redirectUrl="/">
          <QuestionnarieListing />
        </RoleGaurd>
      ),
    },
    {
      path: `${PATHS.QUESTIONNARIE}/${PATHS.CREATE}`,
      element: (
        <RoleGaurd module="Questionnaire" permission="Create" isRedirect redirectUrl={`${PATHS.QUESTIONNARIE}`}>
          <AddEditQuestionnarie type="add" />
        </RoleGaurd>
      ),
    },
    {
      path: `${PATHS.QUESTIONNARIE}/${PATHS.EDIT}/:id`,
      element: (
        <RoleGaurd module="Questionnaire" permission="Create" isRedirect redirectUrl={`${PATHS.QUESTIONNARIE}`}>
          <AddEditQuestionnarie type="edit" />
        </RoleGaurd>
      ),
    },
    {
      path: PATHS.WOUND_LISTING,
      element: (
        <RoleGaurd module="Wound Management" permission="View" isRedirect redirectUrl="/">
          <VisitListing type="view" />
        </RoleGaurd>
      ),
    },
    {
      path: PATHS.WOUND_LISTING + "/" + PATHS.WOUND_DETAILS + "/:id",
      element: (
        <RoleGaurd module="Wound Management" permission="View" isRedirect redirectUrl="/">
          <WoundDetails type="wound" />
        </RoleGaurd>
      ),
    },
    {
      path: PATHS.WOUND_LISTING + "/" + PATHS.ASSESSMENT_DETAILS + "/:id",
      element: (
        // <RoleGaurd module="" permission="View" isRedirect redirectUrl="/">
        <WoundDetails type="assessment" />
        // </RoleGaurd>
      ),
    },
    // Static Pages

    {
      path: PATHS.STATIC_PAGES,
      element: (
        <RoleGaurd module="Static Pages" permission="View" isRedirect redirectUrl="/">
          <StaticPages type="view" />
        </RoleGaurd>
      ),
    },
    {
      path: PATHS.STATIC_PAGES + "/" + PATHS.VIEW,
      element: (
        <RoleGaurd module="Static Pages" permission="View" isRedirect redirectUrl="/">
          <StatisPagesViewDetails type="view" />
        </RoleGaurd>
      ),
    },

    {
      path: PATHS.STATIC_PAGES + "/" + PATHS.EDIT,
      element: (
        <RoleGaurd module="Static Pages" permission="Edit" isRedirect redirectUrl="/">
          <AddStaticPage type="edit" />
        </RoleGaurd>
      ),
    },

    {
      path: "",
      element: <Navigate to={`${PATHS.STATIC_PAGES}`} />,
    },
    {
      path: PATHS.ANY,
      element: <Navigate to={`${PATHS.STATIC_PAGES}`} />,
    },
    // Role
    {
      path: PATHS.ROLE,
      element: (
        <RoleGaurd module="Role" permission="View" isRedirect redirectUrl="/">
          <RoleManagement type="view" />{" "}
        </RoleGaurd>
      ),
      children: [
        {
          path: "",
          element: <RolePage />,
        },
        {
          path: PATHS.CREATE,
          element: (
            <RoleGaurd module="Role" permission="Create" isRedirect redirectUrl={`/${PATHS.ROLE}`}>
              <AddEditRole type="add" />
            </RoleGaurd>
          ),
        },
        {
          path: PATHS.EDIT + "/" + ":id",
          element: (
            <RoleGaurd module="Role" permission="Edit" isRedirect redirectUrl={`/${PATHS.ROLE}`}>
              <AddEditRole type="edit" />
            </RoleGaurd>
          ),
        },
        {
          path: PATHS.VIEW + "/" + ":id",
          element: <ViewRole type="view" />,
        },
      ],
    },
    // Email And Notifications
    {
      path: PATHS.EMAIL_TEMPLATES,
      element: <EmailTemplatesManagement />,
      children: [
        {
          path: "",
          element: <EmailTemplates />,
        },
        {
          path: PATHS.CREATE,
          element: (
            <RoleGaurd module="Email Template" permission="Create" isRedirect redirectUrl="/">
              <AddEditTemplates type="add" />
            </RoleGaurd>
          ),
        },
        {
          path: PATHS.EDIT,
          element: (
            <RoleGaurd module="Email Template" permission="Edit" isRedirect redirectUrl="/">
              <AddEditTemplates type="edit" />
            </RoleGaurd>
          ),
        },
        {
          path: PATHS.VIEW,
          element: (
            <RoleGaurd module="Email Template" permission="View" isRedirect redirectUrl="/">
              <ViewTemplates type="view" />
            </RoleGaurd>
          ),
        },
      ],
    },
    // Settings
    {
      path: PATHS.SETTINGS,
      element: <Settings />,
      children: [
        {
          path: PATHS.GENERAL_SETTINGS,
          element: (
            <RoutePermissionGate>
              <GeneralSettings />
            </RoutePermissionGate>
          ),
        },

        {
          path: PATHS.SMTP_SMS_DETAILS,
          element: (
            <RoutePermissionGate>
              <SmtpSmsDetails />
            </RoutePermissionGate>
          ),
        },
        {
          path: "",
          element: <Navigate to={`${PATHS.SETTINGS}/${PATHS.GENERAL_SETTINGS}`} />,
        },
        {
          path: PATHS.ANY,
          element: <Navigate to={`${PATHS.SETTINGS}/${PATHS.GENERAL_SETTINGS}`} />,
        },
      ],
    },
    // Common Pages
    {
      path: PATHS.NOTIFICATIONS,
      element: <Notifications />,
    },
    {
      path: PATHS.FourZeroFour,
      element: <FourZeroFourPage />,
    },
    {
      path: PATHS.THANKYOU,
      element: <ThankyouPage />,
    },
    {
      path: PATHS.COMING_SOON,
      element: <ComingSoonPage />,
    },
    // My Profile
    {
      path: PATHS.MY_PROFILE,
      element: <MyProfile />,
    },
    {
      path: PATHS.EDIT_MY_PROFILE,
      element: <EditMyProfile />,
    },
    {
      path: PATHS.CHANGE_PASSWORD,
      element: <ChangePasswordPage />,
    },
  ],
};

const AuthenticationRoutes = {
  path: PATHS.DEFAULT,
  element: (
    <GuestRoute>
      <AuthLayout />
    </GuestRoute>
  ),
  children: [
    {
      path: PATHS.DEFAULT,
      element: <Login />,
    },
    {
      path: PATHS.OTP_DETAILS,
      element: <OtpDetails />,
    },
    {
      path: PATHS.OTP_VERIFICATION,
      element: <OtpVerification />,
    },
    {
      path: PATHS.FORGOT_PASSWORD,
      element: <ForgotPassword />,
    },
    {
      path: PATHS.RESET_PASSWORD,
      element: <ResetPassword />,
    },
  ],
};

/**
 * @params {boolean}
 * @return {Array} of all paths & routes
 */
export const getRoutes = () => [
  AuthenticationRoutes,
  MainRoutes,
  {
    path: PATHS.ANY,
    element: <FourZeroFourPage />,
  },
];
